var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 23 18",
    style: {
      enableBackground: "new 0 0 23 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3,1.1L6.3,1.1L1.2,6.2C0.9,6.5,0.9,7.1,1.2,7.5l0.1,0.1l5,5c0.4,0.4,1,0.4,1.4,0 C8,12.2,8,11.7,7.7,11.3l-0.1-0.1L4.4,7.9l11.2,0c3.4,0.1,4.9,1.3,4.9,4c0,2.6-1.4,3.7-4.8,3.4c-0.6,0-1,0.4-1.1,0.9 c0,0.6,0.4,1,0.9,1.1c4.5,0.4,7-1.5,7-5.4c0-3.8-2.3-5.8-6.6-6l-0.3,0H4.4l3.3-3.3C8,2.2,8,1.7,7.7,1.3L7.7,1.2 C7.3,0.8,6.7,0.8,6.3,1.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturns);
export default __webpack_public_path__ + "static/media/returns.874841fdf7d3a49e3f91fb37f3dd12fb.svg";
export { ForwardRef as ReactComponent };